import { render, staticRenderFns } from "./moveArea.vue?vue&type=template&id=eaa50a7a&scoped=true"
import script from "./moveArea.vue?vue&type=script&lang=js"
export * from "./moveArea.vue?vue&type=script&lang=js"
import style0 from "./moveArea.vue?vue&type=style&index=0&id=eaa50a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa50a7a",
  null
  
)

export default component.exports